import { useQuery } from '@tanstack/react-query'
import { EventsQueryKeys } from '@/modules/events/keys'
import { getEventById } from '../../services'

export default function useQueryGetEventById(id: string, enabled = true) {
	return useQuery({
		queryKey: [EventsQueryKeys.getEventById, id],
		queryFn: () => getEventById(id),
		enabled: enabled && !!id,
	})
}
